import PropTypes from 'prop-types';
import React from "react";
import reactT from "./../../components/reactT";
class FederatedResultList extends React.Component {

	render() {
		return (
			<React.Fragment>
				<h1 className="element-invisible">{reactT('Search')}</h1>
				<h2 className="element-invisible">{reactT('Search results')}</h2>
				<div className="search-results">
					{this.props.children}
				</div>
			</React.Fragment>
		);
	}
}

FederatedResultList.propTypes = {
	children: PropTypes.array
};

export default FederatedResultList;
